// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hZ_0","col":"styles_col__2rQV9"};